import { render, staticRenderFns } from "./CurrentStep.vue?vue&type=template&id=18ebdf65&scoped=true"
import script from "./CurrentStep.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentStep.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CurrentStep.vue?vue&type=style&index=0&id=18ebdf65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ebdf65",
  null
  
)

export default component.exports